import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const ActiveMarketplaceIcon: React.FC<SvgIconDefaultProps> = ({
  className,
}) => {
  return (
    <CustomSvg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.815 2H8.435C4.795 2 2.625 4.17 2.625 7.81V16.18C2.625 19.83 4.795 22 8.435 22H16.805C20.445 22 22.615 19.83 22.615 16.19V7.81C22.625 4.17 20.455 2 16.815 2ZM8.255 18.15C8.255 18.56 7.915 18.9 7.505 18.9C7.095 18.9 6.755 18.56 6.755 18.15V16.08C6.755 15.67 7.095 15.33 7.505 15.33C7.915 15.33 8.255 15.67 8.255 16.08V18.15ZM13.375 18.15C13.375 18.56 13.035 18.9 12.625 18.9C12.215 18.9 11.875 18.56 11.875 18.15V14C11.875 13.59 12.215 13.25 12.625 13.25C13.035 13.25 13.375 13.59 13.375 14V18.15ZM18.495 18.15C18.495 18.56 18.155 18.9 17.745 18.9C17.335 18.9 16.995 18.56 16.995 18.15V11.93C16.995 11.52 17.335 11.18 17.745 11.18C18.155 11.18 18.495 11.52 18.495 11.93V18.15ZM18.495 8.77C18.495 9.18 18.155 9.52 17.745 9.52C17.335 9.52 16.995 9.18 16.995 8.77V7.8C14.445 10.42 11.255 12.27 7.685 13.16C7.625 13.18 7.565 13.18 7.505 13.18C7.165 13.18 6.865 12.95 6.775 12.61C6.675 12.21 6.915 11.8 7.325 11.7C10.695 10.86 13.695 9.09 16.075 6.59H14.825C14.415 6.59 14.075 6.25 14.075 5.84C14.075 5.43 14.415 5.09 14.825 5.09H17.755C17.795 5.09 17.825 5.11 17.865 5.11C17.915 5.12 17.965 5.12 18.015 5.14C18.065 5.16 18.105 5.19 18.155 5.22C18.185 5.24 18.215 5.25 18.245 5.27C18.255 5.28 18.255 5.29 18.265 5.29C18.305 5.33 18.335 5.37 18.365 5.41C18.395 5.45 18.425 5.48 18.435 5.52C18.455 5.56 18.455 5.6 18.465 5.65C18.475 5.7 18.495 5.75 18.495 5.81C18.495 5.82 18.505 5.83 18.505 5.84V8.77H18.495Z"
        fill="#286AF6"
      />
    </CustomSvg>
  );
};

export default ActiveMarketplaceIcon;
